import {CardBrand} from './CardBrand';

export const CardTypeMap: Record<string, string[]> = {
  [CardBrand.visa]: ['4'],
  [CardBrand.mastercard]: ['5', '2'],
  [CardBrand.discover]: ['6'],
  [CardBrand.amex]: ['3'],
};
